import MenuItem from '@/components/layout/header/MenuItem.vue'
import ExternalMenuItem from '@/components/layout/header/ExternalMenuItem.vue'
import DropdownMenuItem from '@/components/layout/header/DropdownMenuItem.vue'
import RecursiveDropdownMenu from '@/components/layout/header/RecursiveDropdownMenu.vue'

import PostComponent from '@/pages/PostComponent.vue'
import BlogComponent from '@/pages/BlogComponent.vue'

import PostArticle from '@/components/layout/article/PostArticle.vue'
import IssueArticle from '@/components/layout/article/IssueArticle.vue'
import ArchiveArticle from '@/components/layout/article/ArchiveArticle.vue'
import IssueSingleArticle from '@/components/layout/article/IssueSingleArticle.vue'

export const menuTypes = {
  'menu-item': MenuItem,
  'external-menu-item': ExternalMenuItem,
  'dropdown-menu-item': DropdownMenuItem,
  'recursive-dropdown-menu': RecursiveDropdownMenu
}

export const pageTypes = {
  'post': PostComponent,
  'blog': BlogComponent
}

export const contentTypes = {
  'static': PostArticle,
  'issue': IssueArticle,
  'archive': ArchiveArticle
}

export const articleTypes = {
  'static': PostArticle,
  'issue': IssueSingleArticle
}
